interface TransformedAuthData {
  cartItemsCount: number;
  email: string;
  firstName: string;
  formKey: string;
  groupId: string;
  id: string;
  isLoyal: boolean;
  isPro: boolean;
  lastName: string;
  rewardPoints: boolean;
  userName: string;
  iocValue?: number | null;
  priveBand: string | null;
  dob: string | null;
  gender: string | '';
}

export const convertWishlistToArray = (wishlist: any): string[] => {
  const wishlistIndices = Object.keys(wishlist);
  const wishlistItems: string[] = [];

  wishlistIndices.forEach((wishlistIndex) => {
    wishlistItems.push(wishlist[wishlistIndex]);
  });

  return wishlistItems;
};

export const transformAuthData = (authData: any) => {
  const {
    cartItemsTotal,
    form_key: formKey,
    customerData: {
      id,
      loginEmail,
      loginUsername,
      gfirstname: gFirstName,
      glastname: gLastName,
      group_id: groupId,
      nykaa_pro: isPro,
      is_loyal: isLoyal,
      rewardPoints = 0,
      prive_band,
      dob,
      gender,
    },
  } = authData;

  const transformedAuthData: TransformedAuthData = {
    cartItemsCount: cartItemsTotal || 0,
    email: loginEmail || '',
    firstName: gFirstName || '',
    formKey,
    groupId: groupId || '',
    id: id || '',
    isLoyal,
    isPro: !!isPro || false,
    lastName: gLastName || '',
    rewardPoints,
    userName: loginUsername || '',
    priveBand: prive_band || null,
    dob,
    gender,
  };

  return transformedAuthData;
};

interface TransformedUserData {
  firstName: string;
  customerId: string;
  lastName: string;
  birthday: string | null;
  priveBand: string;
  profilePic: string | null;
  priveCrownImage: string | null;
  priveImageBorderUrl: string | null;
}

export const transformUserDetails = (userData: any) => {
  if (!userData) {
    return;
  }
  const {
    firstname,
    customer_id,
    lastname,
    dob = '',
    prive_band,
    profilepic,
    loyaltyProgram: { accounts_section },
  } = userData;
  const updatedDate = new Date(dob).toLocaleDateString('en-US');
  const transformedUserData: TransformedUserData = {
    firstName: firstname || '',
    lastName: lastname,
    customerId: customer_id || '',
    birthday: dob ? updatedDate : null,
    priveBand: prive_band,
    profilePic: profilepic || null,
    ...accounts_section,
  };

  return transformedUserData;
};
